module.exports = __webpack_public_path__ + "img/sample-productManager.ae033832.webp";